import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ImageWithAuth = ({ src, alt, className, getAuthHeader, onClick }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let isMounted = true;
    let objectUrl = null;
    
    const loadImage = async () => {
      if (!src || !getAuthHeader) {
        if (isMounted) {
          setError(true);
          setLoading(false);
        }
        return;
      }

      try {
        setLoading(true);
        setError(false);
        
        const response = await axios.get(src, {
          headers: getAuthHeader(),
          responseType: 'blob'
        });
        
        if (isMounted && response.data) {
          objectUrl = URL.createObjectURL(response.data);
          setImageSrc(objectUrl);
          setLoading(false);
        }
      } catch (err) {
        console.error('Error loading image:', err);
        if (isMounted) {
          setError(true);
          setLoading(false);
        }
      }
    };

    loadImage();

    // Cleanup
    return () => {
      isMounted = false;
      if (objectUrl) {
        try {
          URL.revokeObjectURL(objectUrl);
        } catch (e) {
          console.error('Error revoking object URL:', e);
        }
      }
    };
  }, [src]); // Only depend on src

  if (loading) {
    return (
      <div className={`${className} flex items-center justify-center bg-gray-200 animate-pulse`}>
        <div className="text-gray-400 text-xs">Laden...</div>
      </div>
    );
  }

  if (error || !imageSrc) {
    return (
      <div className={`${className} flex items-center justify-center bg-gray-200`}>
        <div className="text-gray-400 text-xs">❌</div>
      </div>
    );
  }

  return (
    <img
      src={imageSrc}
      alt={alt || 'Image'}
      className={className}
      onClick={onClick}
      onError={() => {
        console.error('Image failed to load');
        setError(true);
      }}
    />
  );
};

export default ImageWithAuth;
